import qs from 'qs';
import router from '@/router';

export const handleJSON = response => {
  const contentType = response.headers.get('content-type');
  if (response.status === 401) {
    if (router.history.current.path !== '/login') {
      router.push({ name: 'login' }).catch(error => {
        throw new Error(error);
      });
      return Promise.reject(new Error('Unauthorized'));
    }
  }

  if (contentType && contentType.includes('application/json')) {
    return response.json().then(json => {
      return response.ok ? json : Promise.reject(json);
    });
  }

  // Handle No content response
  if (response.status === 204) {
    return Promise.resolve();
  }
  Rollbar.debug('Server response is not a JSON.', response);
  return Promise.reject(new Error('Server response is not a JSON.'));
};

export const handleJSONForForm = response => {
  /*
    This uses original handleJSON, but converts its string errors
    to an object with 'non_field_errors' key.
    Useful for forms that expect errors to always be a JSON.
  */
  return handleJSON(response).catch(error => {
    if (typeof error === 'string') {
      const errors = { non_field_errors: [error] };
      return Promise.reject(errors);
    }

    if (error instanceof Error) {
      const errors = { non_field_errors: [error.message] };
      return Promise.reject(errors);
    }

    return Promise.reject(error);
  });
};

export const stringifyParams = params => {
  return qs.stringify(params, {
    addQueryPrefix: true,
    arrayFormat: 'comma',
    encode: false,
    indices: false,
    skipNulls: true,
  });
};

export const stringifyEncodeParams = params => {
  return qs.stringify(params, {
    addQueryPrefix: true,
    arrayFormat: 'comma',
    encode: true,
    indices: false,
    skipNulls: true,
  });
};

export default { handleJSON, stringifyParams, stringifyEncodeParams };
